<div
  [ngClass]="{
    'drop-down__content': renderMode === 'drop-down',
    'drop-down__content--open': renderMode === 'drop-down' && !!(shouldShowDropDown | async),
  }"
>
  <ng-content></ng-content>
</div>
